import { type SVGProps } from 'react';

export const ArrowRightIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        width={24}
        height={24}
        {...props}
    >
        <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z" />
    </svg>
);
